import React from 'react';
import PropTypes from 'prop-types';

import SecondaryCta from 'components/Buttons/SecondaryCta';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';

const ShowAllGuestButton = ({ dinersCount, handleOnClick }) => {
  return (
    <SecondaryCta
      handleClick={handleOnClick}
      label={`Show all ${dinersCount} Guests`}
      ownState={getOwnCartDrawerState()}
      sx={{ marginTop: '24px' }}
      dataTestId="show-all-guests-button"
    />
  );
};

ShowAllGuestButton.propTypes = {
  dinersCount: PropTypes.number.isRequired,
  handleOnClick: PropTypes.func.isRequired
};

export default ShowAllGuestButton;
